import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin, Heart, CheckCircle2, AlertCircle } from 'lucide-react';
import { sendViaWeb3Forms } from '../services/web3formsService';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setStatus('error');
      setMessage('Veuillez entrer une adresse email valide.');
      return;
    }
    setStatus('loading');
    setMessage('');
    const result = await sendViaWeb3Forms({
      type: 'newsletter',
      fields: {
        email
      }
    });
    if (result.success) {
      setStatus('success');
      setMessage("🎉 Inscription réussie ! Merci de votre intérêt pour l'ADCC.");
      setEmail('');
      setTimeout(() => {
        setStatus('idle');
        setMessage('');
      }, 5000);
    } else {
      setStatus('error');
      setMessage(result.message);
      setTimeout(() => {
        setStatus('idle');
        setMessage('');
      }, 5000);
    }
  };
  return <footer className="bg-[#1a2332] text-gray-300 pt-16 pb-8" data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-29">
          {/* ADCC Logo & Description */}
          <div data-id="element-30">
            <Link to="/" className="inline-block mb-4" data-id="element-31">
              <img src="https://cdn.magicpatterns.com/uploads/aDkmxbvuRnuoxKgNwqBiWA/ADCC_logo.png" alt="ADCC" className="h-12 w-auto" data-id="element-32" />
            </Link>
            <p className="text-sm font-medium text-gray-300 mb-1" data-id="element-33">
              Association Dignité Compétence Création.
            </p>
            <p className="text-sm leading-relaxed mb-6 text-gray-400" data-id="element-34">
              Œuvrer pour un développement durable et inclusif au Bénin.
            </p>
            <div className="flex gap-3" data-id="element-35">
              <a href="https://www.facebook.com/profile.php?id=61587454706476" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-700/50 rounded-lg flex items-center justify-center text-gray-400 hover:text-white hover:bg-[#1E88E5] transition-all" aria-label="Facebook" data-id="element-36">
                <Facebook className="h-4 w-4" data-id="element-37" />
              </a>
              <a href="https://www.linkedin.com/company/association-dignit%C3%A9-comp%C3%A9tence-cr%C3%A9ation-adcc" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-700/50 rounded-lg flex items-center justify-center text-gray-400 hover:text-white hover:bg-[#1E88E5] transition-all" aria-label="LinkedIn" data-id="element-38">
                <Linkedin className="h-4 w-4" data-id="element-39" />
              </a>
              <a href="https://www.instagram.com/adcc.benin" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-700/50 rounded-lg flex items-center justify-center text-gray-400 hover:text-white hover:bg-[#1E88E5] transition-all" aria-label="Instagram" data-id="element-40">
                <Instagram className="h-4 w-4" data-id="element-41" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div data-id="element-42">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-43">Navigation</h3>
            <ul className="space-y-3 text-sm" data-id="element-44">
              {[{
              name: 'Accueil',
              href: '/'
            }, {
              name: 'À Propos',
              href: '/about'
            }, {
              name: 'Nos Actions',
              href: '/actions'
            }, {
              name: 'Notre Vision',
              href: '/impact'
            }, {
              name: 'Blog',
              href: '/blog'
            }, {
              name: 'Devenir Formateur',
              href: '/formateurs'
            }, {
              name: 'Devenir Bénévole',
              href: '/benevoles'
            }].map(link => <li key={link.name} data-id="element-45">
                  <Link to={link.href} className="text-gray-400 hover:text-white transition-colors" data-id="element-46">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-47">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-48">Contact</h3>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-49">
              <li className="flex items-start gap-3" data-id="element-50">
                <MapPin className="w-5 h-5 text-[#1E88E5] flex-shrink-0" data-id="element-51" />
                <span data-id="element-52">
                  Cotonou, Bénin
                  <br data-id="element-53" />
                  Quartier Haie Vive
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-54">
                <Phone className="w-5 h-5 text-[#1E88E5] flex-shrink-0" data-id="element-55" />
                <span data-id="element-56">+229 01 59 11 13 30</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-57">
                <Mail className="w-5 h-5 text-[#1E88E5] flex-shrink-0" data-id="element-58" />
                <span data-id="element-59">contact@adcc.africa</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-60">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-61">Newsletter</h3>
            <p className="text-sm mb-4 text-gray-400" data-id="element-62">
              Restez informé de nos actions et événements.
            </p>
            <form onSubmit={handleNewsletterSubmit} className="space-y-2" data-id="element-63">
              <div className="relative" data-id="element-64">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Votre email" className="w-full bg-gray-800 border border-gray-700 rounded-md py-2 px-4 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#1E88E5] focus:ring-1 focus:ring-[#1E88E5]" disabled={status === 'loading' || status === 'success'} data-id="element-65" />
              </div>
              <button type="submit" disabled={status === 'loading' || status === 'success'} className="w-full bg-[#1E88E5] hover:bg-[#1976D2] text-white px-4 py-2 rounded-md text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-66">
                {status === 'loading' ? <span className="flex items-center gap-2" data-id="element-67">
                    <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-68" />
                    Inscription...
                  </span> : "S'inscrire"}
              </button>

              {message && <div className={`flex items-start gap-2 text-xs p-2 rounded ${status === 'success' ? 'bg-green-500/20 text-green-200' : 'bg-red-500/20 text-red-200'}`} data-id="element-69">
                  {status === 'success' ? <CheckCircle2 className="h-4 w-4 flex-shrink-0 mt-0.5" data-id="element-70" /> : <AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" data-id="element-71" />}
                  <span data-id="element-72">{message}</span>
                </div>}
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700/50 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-73">
          <p data-id="element-74">© {new Date().getFullYear()} ADCC Bénin. Tous droits réservés.</p>
          <p className="flex items-center gap-1" data-id="element-75">
            Fait avec{' '}
            <Heart className="w-3.5 h-3.5 text-red-400 fill-red-400" data-id="element-76" /> pour la
            communauté
          </p>
        </div>
      </div>
    </footer>;
}